const CROSSROADS_EXPERIENCES_MESHES = [
    'shadeGray.004',
    'shadeBrown.004',
    'shadeWhite.084',
    'shadeWhite_001.001',
    'shadeWhite_015.013',
    'shadeWhite_015.014',
    'shadeWhite_015.015',
    'shadeWhite_015.016',
    'shadeWhite_015.017',
]

const CROSSROADS_PROJECTS_MESHES = [
    'shadeGray.005',
    'shadeBrown.005',
    'shadeWhite.085',
    'shadeWhite_015.011',
    'shadeWhite_015.012',
]

const PLAYGROUND_EXPERIENCES_MESHES = [
    'shadeWhite_015.020',
    'shadeWhite_015.021',
    'shadeWhite_015.024',
    'shadeWhite_015.025',
]

function normalizedName(_name)
{
    return (_name || '').replace(/[.:/[\]]/g, '')
}

export function removeMeshesByName(_scene, _names)
{
    const names = new Set()

    for(const name of _names)
    {
        names.add(name)
        names.add(normalizedName(name))
    }

    const remove = []

    _scene.traverse((child) =>
    {
        const originalName = child.userData && child.userData.name

        if(names.has(child.name) || names.has(originalName) || names.has(normalizedName(child.name)))
        {
            remove.push(child)
        }
    })

    for(const child of remove)
    {
        child.removeFromParent()
    }
}

export function hideBakedDirectionSigns(_resources)
{
    removeMeshesByName(
        _resources.items.crossroadsStaticBase.scene,
        [...CROSSROADS_EXPERIENCES_MESHES, ...CROSSROADS_PROJECTS_MESHES],
    )

    removeMeshesByName(
        _resources.items.playgroundStaticBase.scene,
        PLAYGROUND_EXPERIENCES_MESHES,
    )
}

// Backwards-compatible alias
export const hideBakedExperiencesSigns = hideBakedDirectionSigns
